module.exports = __webpack_public_path__ + "static/img/products application_Clear PVC4.1d946bc3.jpg";